/**
 * Push Notification Subscribers List
 * Shows active push notification subscribers
 */
import { Bell, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const formatDate = (dateStr) => {
  if (!dateStr) return 'Never';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-FJ', { 
    month: 'short', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export default function SubscribersList({ subscribers = [], onTestSubscriber }) {
  return (
    <Card className="bg-card border-border">
      <CardHeader>
        <CardTitle className="text-foreground">Active Subscribers</CardTitle>
        <CardDescription>Users who have enabled push notifications</CardDescription>
      </CardHeader>
      <CardContent>
        {subscribers.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Bell className="w-12 h-12 mx-auto mb-4 opacity-50" />
            <p>No active subscribers yet</p>
            <p className="text-sm">Users can enable notifications from the Loyalty page</p>
          </div>
        ) : (
          <div className="space-y-2">
            {subscribers.map((sub, idx) => (
              <div 
                key={idx}
                className="flex items-center justify-between p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className={`h-2 w-2 rounded-full ${sub.is_active ? 'bg-green-500' : 'bg-gray-400'}`} />
                  <div>
                    <p className="font-medium text-foreground">{sub.email || sub.customer_id || 'Anonymous'}</p>
                    <p className="text-xs text-muted-foreground">
                      Subscribed {formatDate(sub.created_at)}
                      {sub.last_used && ` • Last active ${formatDate(sub.last_used)}`}
                    </p>
                  </div>
                </div>
                <Button 
                  variant="ghost" 
                  size="sm"
                  onClick={() => onTestSubscriber?.(sub.email || sub.customer_id)}
                  data-testid={`test-sub-${idx}`}
                >
                  <Send className="w-4 h-4" />
                </Button>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
